<template>
  <div class="main dl_gray_color_bg">
    <mt-header :title="$t('我的邀请')" class="dl_header_white dl_line_bottom" fixed>
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>

    <div class="box-all">
      <div class="container">
        <div class="title f18">{{ $t("邀请累计") }}</div>
        <div class="num">{{ total_all_sum }} {{ $t("积分") }}</div>
        <hr />
        <div class="reg f16">
          {{ $t("好友注册") }} {{ total_reg_count }}{{ $t("人数") }}
        </div>
        <div class="bottom">
          <div class="left f20">{{ count_reg_1 }}</div>
          <div class="middle f20">{{ count_reg_2 }}</div>
          <div class="right f20">{{ count_reg_3 }}</div>
        </div>
        <div class="bottom h40">
          <div class="left">
            <div class="f14">{{ $t("一级好友数") }}</div>
            <div class="f12">
              <!-- {{ invite_1_reg_parent_reward }} -->
              {{
                $t("积分 每人奖励", {
                  msg: invite_1_reg_parent_reward,
                })
              }}
            </div>
          </div>
          <div class="middle">
            <div class="f14">{{ $t("二级好友数") }}</div>
            <div class="f12">
              <!-- {{ invite_2_reg_parent_reward }} -->
              {{
                $t("积分 每人奖励", {
                  msg: invite_2_reg_parent_reward,
                })
              }}
            </div>
          </div>
          <div class="right">
            <div class="f14">{{ $t("三级好友数") }}</div>
            <div class="f12">
              <!--  {{ invite_3_reg_parent_reward }} -->

              {{
                $t("积分 每人奖励", {
                  msg: invite_3_reg_parent_reward,
                })
              }}
            </div>
          </div>
        </div>
        <div style="margin-bottom: 40px"></div>
        <div class="reg f16">
          {{ $t("好友存币数") }} {{ total_deposit_count }}{{ $t("人数") }}
        </div>
        <div class="bottom">
          <div class="left f20">{{ count_deposit_1 }}</div>
          <div class="middle f20">{{ count_deposit_2 }}</div>
          <div class="right f20">{{ count_deposit_3 }}</div>
        </div>
        <div class="bottom">
          <div class="left">
            <div class="f14">{{ $t("一级好友数2") }}</div>
            <div class="f12">
              {{
                $t("积分 每人奖励2", {
                  msg: invite_1_deposit_parent_reward,
                })
              }}
            </div>
          </div>
          <div class="middle">
            <div class="f14">{{ $t("二级好友数2") }}</div>
            <div class="f12">
              {{
                $t("积分 每人奖励2", {
                  msg: invite_2_deposit_parent_reward,
                })
              }}
            </div>
          </div>
          <div class="right">
            <div class="f14">{{ $t("三级好友数2") }}</div>
            <div class="f12">
              {{
                $t("积分 每人奖励2", {
                  msg: invite_3_deposit_parent_reward,
                })
              }}
            </div>
          </div>
        </div>
      </div>

      <div class="container2">
        <div class="f18 yao_title fb">{{ $t("邀请列表") }}</div>
        <div class="footer">
          <div class="item" v-bind:class="{ active: reg_show }" @click="zhuce()">
            <div class="detail">
              <span class="fb">{{ $t("邀请注册") }}</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="item right" v-bind:class="{ active: !reg_show }" @click="cunbi()">
            <div class="detail">
              <span class="fb">{{ $t("邀请存币") }}</span>
            </div>
          </div>
        </div>
        <ul class="content_detail">
          <div class="yao_empty f14" ref="block_list">
            {{ $t("暂时没有邀请哦") }}
          </div>
          <li v-for="val in regListInfo">
            <div class="list_reg f14">
              <span class="left">{{ val.mobile || val.user_email }}</span>
              <span class="right">{{ val.ctime }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { httpGetInvitationInfo } from "@/api/userCenter";
import {
  httpInvitationInfo,
  httpInvitationRegList,
  httpDepositUserList,
} from "@/api/index";
export default {
  name: "InvitationDetail",
  components: { Toast },
  data() {
    return {
      reg_show: true,
      count_reg_1: 0,
      count_reg_2: 0,
      count_reg_3: 0,
      count_deposit_1: 0,
      count_deposit_2: 0,
      count_deposit_3: 0,
      total_all_sum: 0,
      total_reg_count: 0,
      total_deposit_count: 0,
      invite_1_reg_parent_reward: 0,
      invite_2_reg_parent_reward: 0,
      invite_3_reg_parent_reward: 0,
      invite_1_deposit_parent_reward: 0,
      invite_2_deposit_parent_reward: 0,
      invite_3_deposit_parent_reward: 0,
      regListInfo: {},
      hot: {},
    };
  },
  methods: {
    goback: function () {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    zhuce: function () {
      this.reg_show = true;
      this.getRegList();
    },
    cunbi: function () {
      this.reg_show = false;
      this.getDepositUserList();
    },
    getRegList: function () {
      httpInvitationRegList()
        .then((res) => {
          this.regListInfo = res.data.list;
          if (this.regListInfo.length == 0) {
            this.$refs.block_list.style.display = "block";
          } else {
            this.$refs.block_list.style.display = "none";
          }
        })
        .catch(() => { });
    },
    getDepositUserList: function () {
      httpDepositUserList()
        .then((res) => {
          this.regListInfo = res.data.list;
          if (this.regListInfo.length == 0) {
            this.$refs.block_list.style.display = "block";
          } else {
            this.$refs.block_list.style.display = "none";
          }
        })
        .catch(() => { });
    },
    getInfo: function () {
      httpInvitationInfo()
        .then((res) => {
          this.count_reg_1 = res.data.count_reg_1;
          this.count_reg_2 = res.data.count_reg_2;
          this.count_reg_3 = res.data.count_reg_3;
          this.count_deposit_1 = res.data.count_deposit_1;
          this.count_deposit_2 = res.data.count_deposit_2;
          this.count_deposit_3 = res.data.count_deposit_3;
          this.total_all_sum = res.data.total_all_sum;
          this.total_reg_count = res.data.total_reg_count;
          this.total_deposit_count = res.data.total_deposit_count;
          this.invite_1_reg_parent_reward = res.data.invite_1_reg_parent_reward;
          this.invite_2_reg_parent_reward = res.data.invite_2_reg_parent_reward;
          this.invite_3_reg_parent_reward = res.data.invite_3_reg_parent_reward;
          this.invite_1_deposit_parent_reward =
            res.data.invite_1_deposit_parent_reward;
          this.invite_2_deposit_parent_reward =
            res.data.invite_2_deposit_parent_reward;
          this.invite_3_deposit_parent_reward =
            res.data.invite_3_deposit_parent_reward;
        })
        .catch(() => { });
    },
  },
  mounted() { },
  activated: function () {
    this.getInfo();
    this.getRegList();
  },
};
</script>

<style lang="less" scoped>
.main {
  padding-top: 40px;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;

  /deep/.mint-header-title {

    // glyph-orientation-vertical: show;
    overflow: inherit;
  }
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.list_reg {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eee;
  position: relative;

  .left {
    position: absolute;
    left: 0;
  }

  .right {
    position: absolute;
    right: 0;
  }
}

/*邀请注册列表*/
.content_detail {
  padding: 20px 15px 0 15px;
  background-color: #fff;
  box-shadow: 2px 2px 3px 0px #dedede;
}

.content_detail li {
  width: 100%;
  background: #fff;
}

.yao_empty {
  line-height: 70px;
  font-weight: bold;
  color: #8a8ca5;
}

.oImg {
  width: 34px;
  height: 34px;
  margin: 15px 10px 5px 14px;
}

.currency_name {
  position: relative;
  top: -20px;
  font-size: 14px;
  font-weight: bold;
}

.amount_of {
  width: 25%;
  text-align: center;
}

.count {
  color: #0191f5;
  padding: 22px 0 10px 0;
  font-weight: bold;
}

.money {
  color: #8c92a8;
}

.box-all {
  padding: 20px 5%;
}

.container2 {
  text-align: center;

  .yao_title {
    padding: 30px 0 20px 0;
  }

  .footer {
    width: 100%;
    height: 50px;
    position: relative;
    border-bottom: 1px solid #eeedf4;

    .item {
      width: 50%;
      height: 100%;
      font-size: 16px;
      color: #212529;
      text-align: center;
      background: #fff;
      position: absolute;
      top: 0;

      .detail {
        position: absolute;
        width: 80px;
        left: 50%;
        margin: 0 0 0 -40px;
        line-height: 48px;

        span {
          border: 1px;
          font-size: 10px;
          white-space: nowrap;
        }
      }
    }

    .item.active {
      color: #335bdc;

      .detail {
        border-bottom: 2px solid #335bdc;
        font-size: 12px;
        white-space: nowrap;
      }
    }
  }

  .footer .item.right {
    right: 0;
  }
}

.fb {
  font-weight: bold;
}

.h40 {
  height: 40px;
}

.l50 {
  line-height: 50px;
}

.f20 {
  font-size: 20px;
  font-weight: bold;
  line-height: 50px;
}

.f18 {
  font-size: 18px;
}

.f16 {
  font-size: 16px;
}

.f14 {
  font-size: 14px;
}

.f12 {
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  margin: 0 2px;
}

.container {
  padding: 10px 10px 22px;
  background-color: #474956;
  border-radius: 10px;
  text-align: center;
  color: #fff;

  .title {
    padding: 20px 0 0 0;
    color: #ffe6ac;
  }

  .num {
    color: #ffe6ac;
    font-size: 20px;
    font-weight: bold;
  }

  hr {
    margin: 20px 0;
    height: 1px;
    border: 0px;
    border-top: 1px solid #666875;
    padding: 0px;
    overflow: hidden;
    font-size: 0px;
  }

  .top,
  .bottom {
    padding: 0 !important;
    line-height: 25px;
    height: 50px;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-around;
    font-size: 20px;

    .left {
      // width: 30%;
      // position: absolute;
      left: 0;
      top: 0;
      text-align: center;
    }

    .middle {
      // width: 40%;
      // position: absolute;
      left: 0;
      top: 0;
      text-align: center;
    }

    .right {
      // width: 30%;
      // position: absolute;
      right: 0;
      top: 0;
      text-align: center;
    }
  }
}
</style>
